import React from 'react';
import PaymentFailedContainer from '../../../Containers/UserContainer/PaymentFaild';

const PaymentFailedScreen = () => {
  return <PaymentFailedContainer />;
};

export default PaymentFailedScreen;
